module.exports = __webpack_public_path__ + "r-v3/img/img-device-authority.d41d8cd9.png";